module.exports = __webpack_public_path__ + "static/media/box-up.4f64196d.svg";